const changeTopic = topic => {
    return {
        type: "CHANGE_TOPIC",
        body: topic
    }
};

const setCurrentApp = currentApp => {
    return {
        type: "SET_CURRENT_APP",
        currentApp
    }
};

const addBlock = params => {
    return {
        type: "ADD_BLOCK_TO_SENTENCE",
        block: params
    }
};

const updateBlocks = blocks => {
    return {
        type: "UPDATE_BLOCKS",
        blocks
    }
};

const saveColors = topicColors => {
    return {
        type: 'SAVE_COLORS',
        topicColors
    }
};

const setCurrentPlayingId = params => {
    return {
        type: 'SET_CURRENT_PLAYING_ID',
        currentPlayingId: params.currentPlayingId,
        playOneBlockOnly: params.playOneBlockOnly,
    }
};

const toggleHeader = toggleHeader => {
	return {
		type: 'TOGGLE_HEADER',
        toggleHeader
	}
};

const setShowActiveOnly = showActiveOnly => {
    return {
        type: 'SHOW_ACTIVE_ONLY',
        showActiveOnly: showActiveOnly
    }
};

const setTopic = selectedTopic => {
    return {
        type: 'SET_TOPIC',
        selectedTopic
    }
};

const updateTopicBlocks = selectedTopic => {
    return {
        type: 'UPDATE_TOPIC_BLOCKS',
        selectedTopic
    }
};

export {
    changeTopic, addBlock, updateBlocks, saveColors,
    setCurrentPlayingId, toggleHeader, setShowActiveOnly,
    setTopic, updateTopicBlocks, setCurrentApp
};